<template>
  <div id="app">
    <!-- Header (hide on dashboard) -->
    <AppHeader v-if="!isLoggedIn || !isDashboardRoute" />

    <!-- Global Loader -->
    <GlobalLoader ref="globalLoader" />

    <!-- Route View -->
    <router-view />

    <!-- Footer (hide on dashboard) -->
    <AppFooter v-if="!isLoggedIn || !isDashboardRoute" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import GlobalLoader from "./components/GlobalLoader.vue";
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    GlobalLoader,
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    isDashboardRoute() {
      return this.$route.path.startsWith("/dashboard");
    },
  },
  setup() {
    const globalLoader = ref(null);
    const router = useRouter();

    const toggleLoader = (state) => {
      if (globalLoader.value) {
        globalLoader.value.show = state;
      }
    };

    onMounted(() => {
      router.beforeEach((to, from, next) => {
        toggleLoader(true);
        next();
      });

      router.afterEach(() => {
        // Delay a bit for smoother transition
        setTimeout(() => toggleLoader(false), 1500);
      });
    });

    return {
      globalLoader,
    };
  },
};
</script>

<style>
#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  margin-bottom: 20px;
}

nav a {
  margin: 0 15px;
  text-decoration: none;
  color: #42b983;
}

nav a.router-link-exact-active {
  font-weight: bold;
}
</style>
